// PANTALLA 5 (cierre) — El contraste percepción vs. realidad
// docs/onboarding-master-v2.md, Parte I §5.5.
//
// "El momento de mayor impacto". Dos bloques, en este orden:
//   1. El copy dinámico del cruce percepción × score.
//   2. El cierre de honestidad — SIEMPRE se muestra, el documento lo subraya:
//      "no lo omitas".
import { useEffect } from 'react';
import { getContrastCopy, CALIBRATION_HONESTY_CLOSE } from '../onboardingContent';
import { revela } from '../sonidos';

export default function CalibrationResult({ perceivedLevel, result, onNext }) {
  const contrast = getContrastCopy(perceivedLevel, result.technical_score);

  // La nota aparece sola, sin que el alumno toque nada: es el momento que el
  // documento maestro llama «de mayor impacto», y ahora llega acompañado.
  useEffect(() => { revela(); }, []);

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">Tu fotografía inicial</p>

      <div className="ob-score-badge">
        <span className="ob-score-value">{result.technical_score}</span>
        <span className="ob-score-label">/ 10 · {result.estimated_cefr}</span>
      </div>

      <div className="ob-reveal-block ob-highlight">
        <p>{contrast}</p>
      </div>

      {/* Cierre de honestidad — obligatorio en toda ejecución del flujo */}
      <p className="ob-honesty">{CALIBRATION_HONESTY_CLOSE}</p>

      <div className="ob-actions">
        <button type="button" className="ob-btn" onClick={onNext}>
          Continuar →
        </button>
      </div>
    </div>
  );
}
